import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from 'reactstrap';
import jwt_decode, { JwtPayload } from 'jwt-decode';

const ModalNotification: React.FC = () => {
  const [dateLimit] = useState('14/02/2024');
  const [userData, setUserData] = useState<any>('');
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const location = useLocation();

  const handleDate = useCallback(() => {
    const date = new Date();
    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const year = date.getFullYear();

    return {
      date: `${day}/${month}/${year}`,
      dateExpired: `${day}/${month}/${year}` >= dateLimit,
      month,
    };
  }, [dateLimit]);

  const handleVerifyUserData = useCallback(
    async (notice) => {
      const userData = localStorage.getItem('userData');

      if (userData) {
        const data = JSON.parse(userData);
        const accessToken = data?.accessToken;
        const decodedToken = jwt_decode<JwtPayload>(accessToken);
        const currentDate = new Date();

        if ((decodedToken.exp ?? 0) * 1000 < currentDate.getTime()) {
          setModal(false);
          return;
        }

        if (handleDate().dateExpired) {
          setModal(false);
          return;
        }

        if (notice <= handleDate().month) {
          setModal(false);
          return;
        }

        if (data.two_factor_authentication === 0) {
          setModal(false);
          return;
        }

        setModal(true);
      }
    },
    [handleDate]
  );

  const handleHideModal = () => {
    localStorage.setItem(`notice${userData.iduser}`, handleDate().month);
    toggle();
  };

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const data = JSON.parse(userData ?? '');
      const notice = localStorage.getItem(`notice${data.iduser}`);
      setUserData(data);
      handleVerifyUserData(notice);
    }
  }, [location.pathname, handleVerifyUserData]);

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} centered backdrop="static">
        <ModalHeader>Notificação</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <h3 className="text-primary my-2">Prezados.</h3>
              <p className="mb-2">
                Informamos que nos dias <strong>12 e 13 de Fevereiro</strong>{' '}
                devido as festas de Carnaval não haverá pagamento aos clientes,
                as atividades voltam ao normal no dia{' '}
                <strong>14 de Fevereiro.</strong>
              </p>
              <p className="mb-2">Obrigado.</p>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleHideModal()}>
            Estou ciente
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalNotification;
